import type {
  DeviceChangesCallLog,
  MapperOfStatusValue,
  TargetDeviceDetailsItem,
  TargetDeviceGeneralProps,
} from '@ingenico/react-ui';
import type { TFunction } from 'react-i18next';
import type { DeviceChangesByIdQuery } from '../../model/deviceChangeDetailsPage.model';

export interface DeviceChangeDetailsDrawerProps {
  readonly t: TFunction;
  readonly statusData: MapperOfStatusValue;
  readonly deviceChangesByIdQuery: DeviceChangesByIdQuery;
  readonly targetDeviceIdItem: TargetDeviceDetailsItem;
  readonly targetDeviceGeneralItems: TargetDeviceGeneralProps[];
  readonly errorMessage: string;
  readonly isDeviceCallLogsLoading?: boolean;
  readonly deviceCallLogs?: DeviceChangesCallLog[];
  readonly canShowParameterOutputSection: boolean;
}
